import useWaitForJupyterhubToBeReadyAfterShutdown from './useWaitForJupyterhubToBeReadyAfterShutdown';

export default useWaitForJupyterhubToBeReadyAfterShutdown;
